var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14531 18.0402C7.14179 18.0332 7.13476 18.0227 7.12773 18.0121L1.2682 7.8625C1.2624 7.85196 1.2567 7.84141 1.25108 7.83086C0.726688 6.89922 1.04949 5.71445 1.97909 5.17656L8.75898 1.26255C9.69414 0.722055 10.893 1.04282 11.4344 1.9791L17.3055 12.1481C17.8434 13.0797 17.527 14.2715 16.6023 14.7848C16.5953 14.8199 16.5848 14.8234 16.5777 14.8305L9.81718 18.7328C9.81015 18.7363 9.80312 18.7398 9.79257 18.7469C8.86796 19.2707 7.69023 18.9578 7.14531 18.0402ZM9.24062 17.766L9.24414 17.7625L16.0258 13.8496L16.0293 13.8461C16.423 13.6106 16.5566 13.1008 16.3246 12.7035L10.4641 2.55145C10.232 2.1482 9.71523 2.00969 9.31093 2.24277L2.55144 6.14688C2.15312 6.37539 2.0132 6.88164 2.23363 7.28242L2.23679 7.28945L8.10859 17.4602L8.1121 17.4637C8.31601 17.8504 8.84687 17.984 9.24062 17.766ZM13.5613 17.868C13.593 17.8715 13.6246 17.875 13.6562 17.875H21.5312C21.9988 17.875 22.375 17.4988 22.375 17.0313V5.18711C22.375 4.75117 21.9988 4.34336 21.5312 4.34336H14.1133L13.4699 3.25879C13.5332 3.25281 13.593 3.21836 13.6562 3.21836H21.5312C22.6176 3.21836 23.5 4.13137 23.5 5.18711V17.0313C23.5 18.1176 22.6176 19 21.5312 19H13.6562C13.1781 19 12.7352 18.8277 12.3941 18.5113L13.5613 17.868Z",
    fill: "#707A83",
    stroke: "#707A83",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicIcon);
export default __webpack_public_path__ + "static/media/topic-icon.f6df619dc1f963289762fc6fa71181df.svg";
export { ForwardRef as ReactComponent };